// extracted by mini-css-extract-plugin
export default {"title":"changeResidualStatusModal_title__zKCXp","content":"changeResidualStatusModal_content__+AVpB"};